<mat-spinner *ngIf="historyLoading" class="device-health-check-history__loading-spinner" diameter="32"></mat-spinner>
<ng-container *ngIf="!historyLoading">
  <ng-container *ngIf="history?.length === 0">
    <span class="device-health-check-history__no-restarts" i18n="@@S_LIVE_MAP_DHC_HISTORY_NO_REQUESTS"
      >There are no restart requests for this vehicle.</span
    >
  </ng-container>
  <ng-container *ngFor="let historyItem of history">
    <div class="device-health-check-history__history-item">
      <span class="device-health-check-history__history-item__header" i18n="@@S_LIVE_MAP_DHC_HISTORY_REQUESTED_DATE">Requested Date</span>
      <span class="device-health-check-history__history-item__value">{{ historyItem.requestedDate | date: 'short' }}</span>

      <span class="device-health-check-history__history-item__header" i18n="@@S_LIVE_MAP_DHC_HISTORY_REQUESTED_BY">Requested By</span>
      <span class="device-health-check-history__history-item__value">{{
        historyItem.requestedByUsername ? historyItem.requestedByUsername : '-'
      }}</span>

      <span class="device-health-check-history__history-item__header i18n=@@S_LIVE_MAP_DHC_HISTORY_STATUS">Status</span>
      <div class="device-health-check-history__history-item__value-container">
        <span
          class="device-health-check-history__history-item__value"
          i18n="@@S_LIVE_MAP_DHC_STATUS_RESTART_SUCCESSFUL"
          *ngIf="
            historyItem.resetStatus === EHealthCheckRequestState.Success && historyItem.pingStatus === EHealthCheckRequestState.Success
          "
          >Restart Successful</span
        >
        <span
          class="device-health-check-history__history-item__value"
          i18n="@@S_LIVE_MAP_DHC_STATUS_RESTART_FAILED"
          *ngIf="
            historyItem.resetStatus === EHealthCheckRequestState.Failure || historyItem.pingStatus === EHealthCheckRequestState.Failure
          "
          >Restart Failed</span
        >
        <span
          class="device-health-check-history__history-item__value"
          i18n="@@S_LIVE_MAP_DHC_STATUS_VEHICLE_ONLINE"
          *ngIf="historyItem.pingStatus === EHealthCheckRequestState.Success"
          >Vehicle Online</span
        >
        <span
          class="device-health-check-history__history-item__value"
          i18n="@@S_LIVE_MAP_DHC_STATUS_VEHICLE_OFFLINE"
          *ngIf="historyItem.pingStatus === EHealthCheckRequestState.Failure"
          >Vehicle Offline</span
        >
        <span
          class="device-health-check-history__history-item__value"
          *ngIf="
            historyItem.pingStatus === EHealthCheckRequestState.Pending || historyItem.resetStatus === EHealthCheckRequestState.Pending
          "
          i18n="@@S_LIVE_MAP_DHC_RESTART_STEP_RESTARTING_1"
          >Restarting tracker.</span
        >
      </div>
    </div>
  </ng-container>
  <button
    *ngIf="history?.length > 0"
    mat-button
    color="accent"
    class="device-health-check-history__view-all-history-button btn-uppercase"
    i18n="@@S_LIVE_MAP_DHC_HISTORY_VIEW_ALL_HISTORY"
    a7s-id="device-health-check-view-all-history"
    (click)="viewAllHistory()"
  >
    VIEW ALL HISTORY
  </button>
</ng-container>
